import { ICreateAccount } from './create-account.helper';

export namespace Account {
  export enum Type {
    PUBLISHER = 'shop',
    ADVERTISER = 'advertiser',
    ORGANIZATION = 'organization'
  }

  export enum TypeUppercase {
    SHOP = 'SHOP',
    ADVERTISER = 'ADVERTISER',
    ORGANIZATION = 'ORGANIZATION'
  }

  export type AdvertiserWithStats = {
    account: ICreateAccount,
    stats: AdvertiserStats
  }

  export type AdvertiserWithStatsResponse = {
    advertiserId: string,
    stats: AdvertiserStats
  }

  export type AdvertiserStats = {
    statsDateFrom: string,
    statsDateTo: string,
    campaignCount: number,
    adCount: number,
    cpc: number,
    clickCount: number,
    showCount: number,
    viewCount: number,
    cost: number,
    ctr: number,
    roi: number,
    income: number,
    soldItemsCount: number,
    conversions: number,
    roas: number,
    acos: number,
    cpm: number,
  }

  export type PublisherWithStats = {
    account: ICreateAccount,
    stats?: PublisherStats
  }
  export type PublisherWithStatsResponse = {
    shopId: string,
    shopName: string,
    stats: PublisherStats
  }

  export type PublisherStats = {
    statsDateFrom: string,
    statsDateTo: string,
    advertiserCount: number,
    productCount: number,
    cpc: number,
    clickCount: number,
    showCount: number,
    income: number,
    ctr: number,
    soldItemsCount: number,
    incomePublisher: number,
    cpm: number,
  }

  export const isPublisher = (arg: Account.Type): arg is Account.Type.PUBLISHER => arg === Account.Type.PUBLISHER;
  export const isAdvertiser = (arg: Account.Type): arg is Account.Type.ADVERTISER => arg === Account.Type.ADVERTISER;
  export const isOrganization = (arg: Account.Type): arg is Account.Type.ORGANIZATION => arg === Account.Type.ORGANIZATION;
}
